/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Member_Login_Method_Sso_Email_HelpInputs */



/**
* | output |
* | --- |
* | "The address {provider} reports for this member. Usually the same as their oneAI address — change it only if their account there uses a different one." |
*
* @param {Member_Login_Method_Sso_Email_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_login_method_sso_email_help = /** @type {((inputs: Member_Login_Method_Sso_Email_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Login_Method_Sso_Email_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Adresse, die ${i?.provider} für dieses Mitglied meldet. In der Regel dieselbe wie die oneAI-Adresse – ändern Sie sie nur, wenn dort eine andere verwendet wird.`)
	return /** @type {LocalizedString} */ (`The address ${i?.provider} reports for this member. Usually the same as their oneAI address — change it only if their account there uses a different one.`)
});